import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "adjust",
  "use": "adjust-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"adjust\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"12\" cy=\"12\" r=\"12\" /><path stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M7.636 17v-3.889m0-2.222V7M12 17v-5m0-2.222V7m4.364 10v-2.778m0-2.222V7M6 13.111h3.273m1.091-3.333h3.272m1.091 4.444H18\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol